export const FORM_NAME = 'malpractice_insurance_applications' as const;
export const MAX_SIZE = 30 as const;
export const ACCEPT = '.pdf, .jpg, .jpeg, .png, .haif' as const;
